import { GET_TEAM_EVENTS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_TEAM_EVENTS}_SUCCESS`) {
    return action.payload.items;
  }
  return state;
};
